const ROUTES = {
  ABOUT: "/about",
  ENSEMBLE: "/ensemble",
  ENSEMBLE_DETAILS: "/ensemble/:id",
  TABLATURE: "/tablature",
  NAVIGATOR: "/",
  CHORDS: "/chords",
  SCALENET: "/scale-network",
  ACCOUNT: "/account",
  SIGN_UP: "/sign-up",
  SIGN_IN: "/sign-in",
  RESET_PWD: "/reset-password",
  CHECKOUT: "/upgrade",
}

export default ROUTES;
